import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { getAccessToken } from "../../../api/garminApi";
import "./GarminConnect.css";
import LoadingPage from "../../common/LoadingPage";

function GarminAccessTokenControl({
    user,
    history
}) {

    const [processing, setProcessing] = useState(true);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        document.title = "Setting Up Garmin Connect Integration | JustGoRide";
        //pull code from querystring
        var urlParams = new URLSearchParams(window.location.search);
        var token = urlParams.get('oauth_token');
        var verifier = urlParams.get('oauth_verifier');

        if (!verifier || verifier === "null") {
            history.push("/user/settings/garmin");
            toast.error(`Garmin Connect integration cancelled!`)
            return; 
        }

        getAccessToken(token, verifier)
            .then(() => {
                history.push("/user/settings/garmin");
                toast.success(`Garmin Connect integrated successfully!`)
                return; 
            })
            .catch(error => {
                toast.error(`There has been an issue setting up Garmin Connect: ${error}`);
                errors.onLoad = "Garmin Connect setup failed: " + error;
                setErrors(errors);
                setProcessing(false);
            })
    }, [])

   
    return (
        processing ?
            <LoadingPage message="Connecting..."/>
            :
            <div className="">
                <div className="garmin-connect row justify-content-center">
                    <div className="make-connection col-12 mx-3 col-sm-10 col-lg-8 col-xl-6">
                    {errors.onLoad &&
                        <div className="alert alert-danger" role="alert">
                            {errors.onLoad}
                        </div>
                    }
                    </div>
                </div>
            </div>
    );
};

GarminAccessTokenControl.propTypes = {
    user: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(GarminAccessTokenControl);


// WEBPACK FOOTER //
// ./src/components/Integrations/Garmin/GarminAccessTokenControl.js